import {createApp} from 'vue';
import {createPinia} from 'pinia';
import * as components from './vue/components/index';
import * as productComponents from './vue/components/product';
import '../styles/main.css';

import './modules/lab_branding';
import './modules/modal';
import './modules/header';
import {addToCart} from './modules/cart';
import {
  publishEngagementTime,
  publishScrollDepth,
  publishCtaClick,
  publishMenuClick,
  publishVarifyTrackingId,
} from './modules/customer-events';

theme.cart = theme.cart || {};
theme.customerEvents = theme.customerEvents || {};

theme.cart.addToCart = addToCart;
theme.customerEvents.publishCtaClick = publishCtaClick;
theme.customerEvents.publishMenuClick = publishMenuClick;
theme.customerEvents.publishScrollDepth = publishScrollDepth;
theme.customerEvents.publishEngagementTime = publishEngagementTime;
theme.customerEvents.publishVarifyTrackingId = publishVarifyTrackingId;

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/* Create Vue instances function */
const createVueApp = (pinia) => {
  const app = createApp({});
  const allComponents = {...components, ...productComponents};

  Object.entries(allComponents).forEach(([name, module]) => {
    app.component(name, module);
  });

  app.use(pinia);

  return app;
};

const vueElements = document.querySelectorAll('[vue]');

if (vueElements) {
  const pinia = createPinia();

  vueElements.forEach((el) => {
    createVueApp(pinia).mount(el);
  });
}

/* properly render vue components on user insert in the theme editor */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      const vueElement = event.target.querySelectorAll('[vue]');
      const pinia = createPinia();
      if (vueElement) {
        vueElement.forEach((el) => {
          createVueApp(pinia).mount(el);
        });

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('modal:reregister'));
        }, 150);
      }
    }
  });
}

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));

  // Prevent Tracking in the Theme Editor
  if (!Shopify.designMode) {
    // Init engagement time tracking
    theme.customerEvents.publishEngagementTime();

    // Init varify tracker
    theme.customerEvents.publishVarifyTrackingId();

    // Init scroll depth tracking
    window.addEventListener('scroll', () => {
      theme.customerEvents.publishScrollDepth();
    });
  }
});
